import { IPayrollDetail, IPayrollOverview } from 'models';
import React, { useContext } from 'react';

export const PayrollReportContext = React.createContext<{
	report?: [IPayrollOverview, IPayrollDetail];
	isDetail?: boolean;
	loading?: boolean;
}>({});
export const usePayrollDetailContext = () => useContext(PayrollReportContext);
